module.exports = __webpack_public_path__ + "static/hero-15d6122e4dc6ca8f40e0c84da5fe96e1.jpg";